// src/data/shuttlesData.js - Contains all shuttle product data
import { getPriceComparisonUrl } from '../utils/productUrlMapping';

export const shuttlesData = [
  {
    id: "hdi-shuttle",
    name: "HDI Shuttle (Assembled)",
    msrp: 240.00,
    image: "https://riversideoutdoors.ca/image/cache/catalog/HD12-500x500.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HDI+Shuttle",
    description: "The full package right out of the box—built-in pole holders, LED lights, USB ports, 1/4-20 mounting points, and a T-Track in the handle make it ready for serious customization with no extra purchases needed. Its tool-less battery access makes it easy to swap batteries or wire in accessories without breaking out tools.",
    notes: "CNC machined from marine grade HDPE - no 3D printed parts. Toolless battery changes and professional wiring harnesses included. Ships fully assembled.",
    csvLookupId: "HDI Shuttle Assembled",
    priceComparisonUrl: getPriceComparisonUrl("HDI Shuttle Assembled"),
    assemblyTime: "0 minutes - ready to go!",
    assemblyType: "assembled",
    construction: "CNC Marine Grade HDPE",
    batteryCompatibility: "Amped 7.5-52ah, Norsk 7.5-52ah, Dakota 10-23ah, Garmin Lithium, 9-12ah lead acid",
    batteryTrayDimensions: "5 7/8″ × 3 29/32″ × 5 1/8″",
    screenCompatibility: "All brands up to 12″ screens",
    switchPanel: "3K Carbon Fiber with 10amp illuminated switches",
    usbPorts: "Dual 2.4amp waterproof USB ports",
    lighting: "Pre-installed aluminum LED UV blue light",
    chargePort: "Front mount SAE battery charge port",
    poleHolders: "Included wheeled pole holder design",
    weight: "TBC",
    loadCapacity: "Professional grade capacity",
    mountingPoints: "1/4-20 mounting points included",
    tTrack: "T-Track in handle for accessories",
    toollessFeatures: "Tool-less battery door",
    wiringHarness: "Fully assembled wire harness included",
    madeIn: "Manufactured internationally",
    releaseYear: "2022",
    bestFor: "Complete, Feature-Rich Setup",
    benefits: [
      "Tool-less battery access for easy maintenance"
    ]
  },
  {
    id: "hdi-shuttle-diy-kit",
    name: "HDI Shuttle (DIY Kit)",
    msrp: 240.00,
    image: "/images/shuttles/HDI_nonassembled.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HDI+Shuttle+DIY",
    description: "The full package right out of the box—built-in pole holders, LED lights, USB ports, 1/4-20 mounting points, and a T-Track in the handle make it ready for serious customization with no extra purchases needed. DIY kit with 40-minute guided assembly video.",
    notes: "CNC machined from marine grade HDPE - no 3D printed parts. Ships as DIY kit with 40-minute guided assembly video. Same quality as assembled version.",
    csvLookupId: "HDI Shuttle NON-Assembled",
    priceComparisonUrl: getPriceComparisonUrl("HDI Shuttle NON-Assembled"),
    assemblyTime: "40 minutes with guided video",
    assemblyType: "diy",
    savings: 50.01,
    construction: "CNC Marine Grade HDPE",
    batteryCompatibility: "Amped 7.5-52ah, Norsk 7.5-52ah, Dakota 10-23ah, Garmin Lithium, 9-12ah lead acid",
    batteryTrayDimensions: "5 7/8″ × 3 29/32″ × 5 1/8″",
    screenCompatibility: "All brands up to 12″ screens",
    switchPanel: "3K Carbon Fiber with 10amp illuminated switches",
    usbPorts: "Dual 2.4amp waterproof USB ports",
    lighting: "Pre-installed aluminum LED UV blue light",
    chargePort: "Front mount SAE battery charge port",
    poleHolders: "Included wheeled pole holder design",
    weight: "TBC",
    loadCapacity: "Professional grade capacity",
    mountingPoints: "1/4-20 mounting points included",
    tTrack: "T-Track in handle for accessories",
    toollessFeatures: "Tool-less battery door",
    wiringHarness: "Fully assembled wire harness included",
    madeIn: "Manufactured internationally",
    releaseYear: "2022",
    bestFor: "Complete, Feature-Rich Setup",
    benefits: [
      "Tool-less battery access for easy maintenance",
      "Save $50+ with DIY assembly"
    ]
  },
  {
    id: "summit-fishing-shuttle",
    name: "Summit CNC Machined Heavy Duty Shuttle",
    msrp: 189.99,
    csvLookupId: "Summit CNC HD Shuttle",
    priceComparisonUrl: getPriceComparisonUrl("Summit CNC HD Shuttle"),
    originalPrice: 219.99,
    image: "https://summitfishingequipment.com/cdn/shop/files/DSC02281-Photoroom_720x.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=Summit+Shuttle",
    description: "Keeps things lighter and simpler by skipping some of the built-in accessories, which gives you more freedom to rig it how you want. While it doesn't come as loaded as some others, it can be purchased with the accessories for extra, it's still a solid, durable platform that's easy to build out to your specific needs.",
    notes: "Made in the USA, precision CNC machined from Marine Grade UV-resistant HDPE. Carries loads exceeding 1,500 lbs while weighing less than aluminum shuttles.",
    assemblyTime: "0 minutes - ready to go!",
    assemblyType: "assembled",
    construction: "CNC Marine Grade HDPE",
    batteryCompatibility: "Amped 7.5-52ah, Norsk 7.5-52ah, Dakota 10-23ah, Garmin Lithium, 9-12ah lead acid",
    batteryTrayDimensions: "5 7/8″ × 3 29/32″ × 5 1/8″",
    shuttleDimensions: "7.5″L × 10.5″W × 12.25″H",
    screenCompatibility: "All brands up to 12″ screens",
    switchPanel: "Fully assembled wire harness with tool-less connections",
    usbPorts: "QC3.0 USB Port + PD USB C port",
    lighting: "HD Light sold separately",
    chargePort: "SAE charge port (Garmin charger not compatible)",
    poleHolders: "Pole holder sold separately",
    weight: "TBC",
    loadCapacity: "Exceeds 1,500 lbs",
    mountingPoints: "None included",
    tTrack: "Not included",
    toollessFeatures: "Requires Phillips driver to open",
    wiringHarness: "Fully assembled wire harness included",
    madeIn: "Made in the USA",
    releaseYear: "2023",
    bestFor: "Simplicity and Custom Rigging",
    benefits: [
      "Strongest shuttle on market - carries 1,500+ lbs"
    ]
  }
  // Add more shuttles as needed
]; 